/**
 * @generated SignedSource<<247748be3ccadc0c10b2a290ba673cf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Header_viewer$data = {
  readonly regionalInfo?: ReadonlyArray<{
    readonly currency: string | null;
    readonly incomeLevel: {
      readonly incomeBracket: string | null;
      readonly incomePercentile: string | null;
    } | null;
  } | null> | null;
  readonly relayIsClient: "Viewer";
  readonly user?: {
    readonly preferences: {
      readonly currency: Currency | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"TopBar_user" | "userTracking_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BottomBar_viewer" | "TopBar_viewer" | "userTracking_viewer">;
  readonly " $fragmentType": "Header_viewer";
};
export type Header_viewer$key = {
  readonly " $data"?: Header_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header_viewer">;
};

import HeaderRefetchQuery_graphql from './HeaderRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "fetchTrackingGdprInfo"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUserRecentHistoryItem"
    },
    {
      "kind": "RootArgument",
      "name": "hasTradeUserId"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "includeTypes"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "localRecentHistoryItemIds"
    },
    {
      "kind": "RootArgument",
      "name": "previewKey"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userIds"
    },
    {
      "kind": "RootArgument",
      "name": "variantId"
    },
    {
      "kind": "RootArgument",
      "name": "zipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": HeaderRefetchQuery_graphql
    }
  },
  "name": "Header_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "relayIsClient",
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "userTracking_viewer"
            }
          ]
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TopBar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BottomBar_viewer"
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "userTracking_user"
                }
              ]
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TopBar_user"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserPreferences",
              "kind": "LinkedField",
              "name": "preferences",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchRegionalInfo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": [
                (v2/*: any*/)
              ],
              "concreteType": "IncomeLevel",
              "kind": "LinkedField",
              "name": "incomeLevel",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "incomeBracket",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "incomePercentile",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "beec392047359154aba0708c379d06e9";

export default node;
